import { Controller } from '@hotwired/stimulus'

// Buscador de producto del formulario de vinculación etiqueta↔producto (PDT-RNK-3518).
//
// El input visible es un autocomplete (Awesomplete vía packs/autocomplete.js) contra
// `tag_opinables#buscar_js`, que devuelve pares { label, value }: el label desambigua
// homónimos (nombre_admin / entidad propietaria / ticker) y el value es el ID de BD.
// Este controller pega las piezas:
//   1. Al cambiar el tipo de producto, apunta el autocomplete al mismo endpoint con el
//      nuevo `opinable_type` y limpia la selección anterior (ya no es de ese tipo).
//   2. Al seleccionar una opción, deja el label visible en el input (el admin ve
//      confirmado QUÉ producto eligió) y guarda el ID en el hidden `opinable_id`.
//   3. Si el admin edita el texto a mano tras seleccionar, invalida el ID guardado
//      (el server rechaza el submit con un error específico si llega vacío).
export default class extends Controller {
  static targets = ['tipo', 'nombre', 'id']
  static values = { url: String }

  cambiaTipo () {
    const url = new URL(this.urlValue, document.location.origin)
    url.searchParams.set('opinable_type', this.tipoTarget.value)
    this.nombreTarget.dataset.autocompleteUrl = `${url.pathname}${url.search}`
    this.nombreTarget.value = ''
    this.idTarget.value = ''
  }

  selecciona (event) {
    this.nombreTarget.value = event.text.label
    this.idTarget.value = event.text.value
  }

  invalidaSeleccion () {
    this.idTarget.value = ''
  }
}
